/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Remove_Vs_DropInputs */



/**
* | output |
* | --- |
* | "What is the difference between Remove player and Drop player?" |
*
* @param {Og_Faq_Q_Remove_Vs_DropInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_remove_vs_drop = /** @type {((inputs?: Og_Faq_Q_Remove_Vs_DropInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Remove_Vs_DropInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelle est la différence entre Retirer le joueur et Déclarer l'abandon ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cuál es la diferencia entre Eliminar jugador y Retirar jugador?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Qual é a diferença entre Remover jogador e Retirar jogador?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Qual è la differenza tra Rimuovi giocatore e Ritira giocatore?")
	return /** @type {LocalizedString} */ ("What is the difference between Remove player and Drop player?")
});